import { uniqueId } from 'lodash';

import { useTranslation } from '@crehana/i18n';
import { createImgixPlaceholder, CustomNextImage } from '@crehana/next';
import { useMediaQuery } from '@crehana/react-hooks';

import { FALLBACK } from '../constants';

import { CompaniesLogosProps } from '../types';

import { AnimatedContainer, SliderTrack } from './CompaniesLogosMobile.styles';

const LogosTrack: React.FC<CompaniesLogosProps> = ({
  logos,
  enableLogosFromAdmin,
}) => {
  const { matches: isSm } = useMediaQuery('sm');

  return (
    <div className="flex flex-row flex-shrink-0">
      {logos.map(({ organizationPublicLogo }, i) => {
        const url = organizationPublicLogo?.logo?.url;
        const placeholder = organizationPublicLogo?.logo?.placeholder;

        if (typeof url === 'string') {
          return (
            <div className="mr-24 sm:mr-32" key={uniqueId()}>
              <CustomNextImage
                src={enableLogosFromAdmin ? url : FALLBACK[i] || FALLBACK[0]}
                blurDataURL={
                  enableLogosFromAdmin
                    ? placeholder
                    : createImgixPlaceholder(FALLBACK[i] || FALLBACK[0])
                }
                placeholder="blur"
                width={!isSm ? 80 : 100}
                height={50}
                objectFit="contain"
              />
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

const CompaniesLogos: React.FC<CompaniesLogosProps> = ({ logos }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-full justify-center mt-56 mb-40 relative">
      <div className="text-center mb-24">
        <h3 className="font-h3 text-primary-main text-24 leading-32">
          {t('COMPANIES_LOGOS_TITLE')}
        </h3>
        <span className="font-body4 text-gray-dark">
          {t('COMPANIES_LOGOS_SUBTITLE')}
        </span>
      </div>

      <AnimatedContainer>
        <SliderTrack quantity={logos.length * 3}>
          <LogosTrack logos={logos} />
          <LogosTrack logos={logos} />
          <LogosTrack logos={logos} />
        </SliderTrack>
      </AnimatedContainer>
    </div>
  );
};

export default CompaniesLogos;
